import * as React from "react";
import { Icon } from "antd";
import { TTranslate } from "../../../service/locale/TranslationService";
import DataGrid from "../../components/app/grid/DataGrid";
import { IReportingPeriodApplicantDocument } from "../../../model/document/ReportingPeriodApplicantDocument";

const PortalDocumentsTable = ({
  documents,
  translate,
  loading
}: {
  documents: IReportingPeriodApplicantDocument[];
  translate: TTranslate;
  loading?: boolean;
}) => {
  const columns = [
    {
      title: translate("portal.reporting_period.documents.name"),
      key: "name",
      dataIndex: "name"
    },
    {
      title: translate("portal.reporting_period.documents.document_type"),
      key: "document-link",
      render: (text, record) =>
        translate(
          `form_version_document_form.document_link_values.${record.documentRelation}`
        )
    },
    {
      dataIndex: "",
      key: "actions",
      render: (text, record) => (
        <a href={`/api/forms/documents/${record.documentId}`} key="download">
          <Icon type="download" style={{ marginRight: 5 }} />
          {translate("portal.reporting_period.documents.download")}
        </a>
      ),
      sorter: undefined,
      fixed: "right",
      width: 100
    }
  ];
  return (
    <DataGrid
      translate={translate}
      columns={columns}
      dataSource={documents}
      loading={loading}
    />
  );
};

export default PortalDocumentsTable;
